import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/api/event-text")({
  staticData: { sitemap: false },
  server: { handlers: { POST: async ({ request }) => {
    const { handleEventText } = await import("@/lib/ai/event-text.server");
    return handleEventText(request);
  } } },
});